<template>
	<div class="courses">
		<fluke-card>
			<header>
				<div class="title">
					Cursos
				</div>
				<div class="description">
					Lista de todos os cursos cadastrados
				</div>
			</header>
			<main>
				<v-data-table
					:headers="headers"
					:items="courses"
					:rows-per-page-items="[15,30,60]"
					rows-per-page-text="Linhas pos página"
					class="inner-tables">

					<template v-slot:items="props">
						<td class="pos_list">
							<div>
								<i v-on:click="c_down(props.item)" class="material-icons">keyboard_arrow_down</i>
								<span>{{ props.item.pos }}</span>
								<i v-on:click="c_up(props.item)" class="material-icons">keyboard_arrow_up</i>
							</div>
						</td>
						<td v-on:click="edit(props.item.id)">{{ props.item.title }}</td>
						<td v-on:click="edit(props.item.id)">{{ props.item.resume }}</td>
					</template>
				</v-data-table>
			</main>
			<footer v-if="permission.write">
				<fluke-button v-on:click.native="addCourse">Adicionar Novo Curso</fluke-button>
			</footer>
		</fluke-card>
	</div>
</template>

<script>
import axios from 'axios';
import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';

import permission from '../../mixins/permissions';


export default {
	mixins: [ permission ],
	components: {
		'fluke-card': Card,
		'fluke-button': Button
	},
	data: function() {
		return {
			courses: [],
			headers: [
				{
					text: "Ordem",
					align: 'left',
					value: 'pos'
				},
				{
					text: "Título",
					align: 'left',
					value: 'title'
				},
				{
					text: "Descrição",
					align: 'left',
					value: 'resume'
				},
			],
			permission: {
				read: false,
				write: false
			}
		}
	},
	created: function() {
		this.getCourses();
		this.permission = this.getUserPagePermission('courses');
		if( this.permission.read == false ) {
			this.$router.push('/');
		}
	},
	methods: {
		addCourse: function() {
			this.$router.push({ name: 'courses-add' });
		},
		getCourses: async function() {
            const result = await axios.get(
				this.$myServerAddresses.courses + 'courses', {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
			);
			this.courses = result.data.map( element => {
				element.pos = element.pos?element.pos:0;
				return element;
			});
		},
		edit: function( index ) {
			this.$router.push({ name: 'courses-edit', params: { id: index } });
		},
		c_up:function( item )
		{
			item.pos = parseInt(item.pos)+1;

			axios.put(
				this.$myServerAddresses.courses + 'courses' + '/up/' + item.id,
				{
					pos: item.pos
				},
				{
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
			)
		},
		c_down:function( item )
		{
			if( item.pos > 0 ) item.pos = parseInt(item.pos)-1;
			axios.put(
				this.$myServerAddresses.courses + 'courses' + '/up/' + item.id,
				{
					pos: item.pos
				},
				{
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
			)
		}
	}
}
</script>
